import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
// @ts-ignore
import ECharts from 'vue-echarts';
import 'echarts';
// @ts-ignore
import rifoTheme2 from '../../../vue-plugin/echarts/theme_2.json';
import optionPriceDom from './data/chart_price_dom';
import optionAvgPrice from './data/chart_avg_price';
import optionMedPrice from './data/chart_med_price';
import optionAvgDom from './data/chart_avg_dom';
import optionSlr from './data/chart_slr';
import optionSales from './data/chart_sales';
import optionPie from './data/chart_pie';
import optionAbortion from './data/chart_abortion';
import optionNewSoldActive from './data/chart_new_sold_active';
import optionPriceDistribute from './data/chart_price_distribute';
import { AxiosPromise } from '../../../utils/axios.promise';
import { CommonConfig } from '../../../configs/config.common';
import SelectPopupCompo from '../../shared/SelectPopupCompo/select.popup.compo.vue';
import * as moment from 'moment';
import { config } from '@fortawesome/fontawesome-svg-core';

// registering map data
const barStyle = {
    normal: {
      color: new ECharts.graphic.LinearGradient(0, 0, 0, 1, [{
        offset: 0,
        color: 'rgba(38, 143, 212, 1)'
      }, {
        offset: 1,
        color: 'rgba(0, 154, 191, 0.6)'
      }])
    }
};
const barStyle2 = {
    normal: {
      color: new ECharts.graphic.LinearGradient(0, 0, 0, 1, [{
        offset: 0,
        color: 'rgba(52, 102, 156, 1)'
      }, {
        offset: 1,
        color: 'rgba(52, 102, 156, 0.6)'
      }])
    }
};

const barStyle3 = {
    normal: {
        color: new ECharts.graphic.LinearGradient(0, 0, 0, 1, [{
          offset: 0,
          color: 'rgba(38, 143, 212, 0.6)'
        }, {
          offset: 1,
          color: 'rgba(0, 154, 191, 0.3)'
        }])
    }
};

ECharts.registerTheme('rifo2', rifoTheme2);
@Component({
    components: {
        'v-chart': ECharts,
        SelectPopupCompo
    },
})
export default class MarketingTrendPage extends Vue {
    // public month_names_short = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    public month_names_short = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];
    public optionPriceDom: any = null;
    public optionAvgPrice: any = null;
    public optionMedPrice: any = null;
    public optionAvgDom: any = null;
    public optionSlr: any = null;
    public optionSales: any = null;
    public optionAvgSaleDay: any = null;
    public optionPie: any = null;
    public optionHistoryData: any = null;
    public optionCurrentData: any = null;
    public optionAbortion: any = null;
    public optionPriceDistribute: any = null;
    public periodSel: any = null;
    public configs = new CommonConfig();
    public currentData: any = null;
    public provienceWindowVisible = false;
    public cityWindowVisible = false;
    public communityWindowVisible = false;
    public propTypeWindowVisible = false;
    public loading = false;
    public loading1 = false;
    public loading2 = false;
    public loading3 = false;
    public loading4 = false;
    public loading5 = false;
    public loading6 = false;
    public provience = 'Ontario';
    public city = 'all';
    public community = 'all';
    public propertyTypeInd: number = 0;
    public allCities: any = [];
    public allCommunities: any = [];
    public propertyTypes: any = [];
    public renderCN: boolean = false;
    public monthTrans(monthVal: number) {
        const month_names_short = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        const month_names_short_cn = ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'];
        if (month_names_short_cn[monthVal]) {
            return month_names_short_cn[monthVal];
        } else {
            return '';
        }
    }
    public renderLang(val: string) {
        if (val === 'all' && this.renderCN) {
            return '全部';
        } else {
            return val;
        }
    }
    public hideWindow() {
        this.provienceWindowVisible = false;
        this.cityWindowVisible = false;
        this.communityWindowVisible = false;
        this.propTypeWindowVisible = false;
    }
    public provienceSelChange(val: any) {
        this.provience = val;
    }
    public async citySelChange(val: any) {
        this.city = val;
        this.community = 'all';
        await this.getAllCommunities(val);
        await this.renderStatistics();
    }
    public async commuSelChange(val: any) {
        this.community = val;
        await this.renderStatistics();
    }
    public async propTypeSelChange(val: any) {
        this.propertyTypeInd = this.propertyTypes.indexOf(val);
        await this.renderStatistics();
    }
    public hasDataOrNot(option: any) {
        return !!(option)
            && !!(option.series)
            && !!(option.series.length)
            && !!(option.series[0].data)
            && !!(option.series[0].data.length);
    }
    public getPeriod(dataArray: any[]) {
        const periodStart =  dataArray[0].year
        + '/' + dataArray[0].month;
        const periodEnd =   dataArray[dataArray.length - 1].year
            + '/' + dataArray[dataArray.length - 1].month;
        return periodStart + '-' + periodEnd;
    }
    public renderPriceDom(rawData: any) {
        const month = rawData.month;
        const data: any = {
            'med_dom': [],
            'med_price': []
        };

        for (let i = 7; i >= 0; i--) {
            let monthNum = (month - i);
            if (monthNum === 0) {
                monthNum = 12;
            } else if ( monthNum < 0) {
                monthNum = (monthNum + 12) % 12;
            }
            data.med_dom.push({
                month: monthNum,
                value: rawData.domHistory[rawData.domHistory.length - 1 - i]
            });
            data.med_price.push({
                month: monthNum,
                value: rawData.priceHistory[rawData.priceHistory.length - 1 - i]
            });
        }
        (optionPriceDom.series[0].name as any) = this.$t('marketingTrend.graph1.label1');
        (optionPriceDom.series[0].data as any) = data.med_dom.map((v: any) => v.value);
        (optionPriceDom.series[1].name as any) = this.$t('marketingTrend.graph1.label2');
        (optionPriceDom.series[1].data as any) = data.med_price.map((v: any) => v.value);
        (optionPriceDom.xAxis[0].data as any) = data.med_dom.map((v: any) => `${this.monthTrans(v.month - 1)}`);
        (optionPriceDom.yAxis[0].name as any) = this.$t('marketingTrend.graph1.label3');
        (optionPriceDom.yAxis[1].name as any) = this.$t('marketingTrend.graph1.label4');
        (optionPriceDom.series[0] as any).itemStyle = barStyle;
        (optionPriceDom.legend.data as any) = [this.$t('marketingTrend.graph1.label2'), this.$t('marketingTrend.graph1.label1')];
        this.optionPriceDom = optionPriceDom;
    }

    public renderAvgPriceOfYear(rawData: any) {
        const month = rawData.month;
        const this_year = rawData.year;
        const data: any = {
            'avg_price_this_year': [],
            'avg_price_last_year': []
        };

        for (let i = 7; i >= 0; i--) {
            let monthNum = (month - i);
            let yearBase = this_year;
            if (monthNum === 0) {
                monthNum = 12;
                yearBase = yearBase - 1;
            } else if ( monthNum < 0) {
                monthNum = (monthNum + 12) % 12;
                yearBase = yearBase - 1;
            }
            data.avg_price_this_year.push({
                month: monthNum,
                year: yearBase,
                value: rawData.priceAvgThis[rawData.priceAvgThis.length - 1 - i]
            });
            data.avg_price_last_year.push({
                month: monthNum,
                year: yearBase - 1,
                value: rawData.priceAvgLast[rawData.priceAvgLast.length - 1 - i]
            });
        }
        const periodThisYear =  this.getPeriod(data.avg_price_this_year);
        const periodLastYear =  this.getPeriod(data.avg_price_last_year);
        (optionAvgPrice.legend.data as any) = [`${periodThisYear}`, `${periodLastYear}`];
        optionAvgPrice.xAxis[0].data = data.avg_price_this_year.map((v: any) => `${this.monthTrans(v.month - 1)}`);
        optionAvgPrice.series[0].name = `${periodThisYear}`;
        optionAvgPrice.series[0].data = data.avg_price_this_year.map((v: any) => v.value);
        optionAvgPrice.series[1].name = `${periodLastYear}`;
        optionAvgPrice.series[1].data = data.avg_price_last_year.map((v: any) => v.value);
        this.optionAvgPrice = optionAvgPrice;
    }
    public renderMedPriceOfYear(rawData: any) {
        const month = rawData.month;
        const this_year = rawData.year;
        const data: any = {
            'med_price_this_year': [],
            'med_price_last_year': []
        };
        for (let i = 7; i >= 0; i--) {
            let monthNum = (month - i);
            let yearBase = this_year;
            if (monthNum === 0) {
                monthNum = 12;
                yearBase = yearBase - 1;
            } else if ( monthNum < 0) {
                monthNum = (monthNum + 12) % 12;
                yearBase = yearBase - 1;
            }
            data.med_price_this_year.push({
                month: monthNum,
                year: yearBase,
                value: rawData.medSlrThis[rawData.medSlrThis.length - 1 - i]
            });
            data.med_price_last_year.push({
                month: monthNum,
                year: yearBase - 1,
                value: rawData.medSlrLast[rawData.medSlrLast.length - 1 - i]
            });
        }
        const periodThisYear =  this.getPeriod(data.med_price_this_year);
        const periodLastYear =  this.getPeriod(data.med_price_last_year);
        (optionMedPrice.legend.data as any) = [`${periodThisYear}`, `${periodLastYear}`];
        optionMedPrice.xAxis[0].data = data.med_price_this_year.map((v: any) => `${this.monthTrans(v.month - 1)}`);
        optionMedPrice.series[0].name = `${periodThisYear}`;
        optionMedPrice.series[0].data = data.med_price_this_year.map((v: any) => v.value);
        optionMedPrice.series[1].name = `${periodLastYear}`;
        optionMedPrice.series[1].data = data.med_price_last_year.map((v: any) => v.value);
        this.optionMedPrice = optionMedPrice;
    }
    public renderDomOfYear(rawData: any) {
        const month = rawData.month;
        const this_year = rawData.year;
        const data: any = {
            'avg_dom_this_year': [],
            'avg_dom_last_year': []
        };
        for (let i = 7; i >= 0; i--) {
            let monthNum = (month - i);
            let yearBase = this_year;
            if (monthNum === 0) {
                monthNum = 12;
                yearBase = yearBase - 1;
            } else if ( monthNum < 0) {
                monthNum = (monthNum + 12) % 12;
                yearBase = yearBase - 1;
            }
            data.avg_dom_this_year.push({
                month: monthNum,
                year: yearBase,
                value: rawData.domAvgThis[rawData.domAvgThis.length - 1 - i]
            });
            data.avg_dom_last_year.push({
                month: monthNum,
                year: yearBase - 1,
                value: rawData.domAvgLast[rawData.domAvgLast.length - 1 - i]
            });
        }
        const periodThisYear =  this.getPeriod(data.avg_dom_this_year);
        const periodLastYear =  this.getPeriod(data.avg_dom_last_year);
        (optionAvgDom.legend.data as any) = [`${periodThisYear}`, `${periodLastYear}`];
        optionAvgDom.xAxis[0].data = data.avg_dom_this_year.map((v: any) => `${this.monthTrans(v.month - 1)}`);
        optionAvgDom.series[0].name = `${periodThisYear}`;
        optionAvgDom.series[0].data = data.avg_dom_this_year.map((v: any) => v.value);
        (optionAvgDom.series[0] as any).itemStyle = barStyle;
        optionAvgDom.series[1].name = `${periodLastYear}`;
        optionAvgDom.series[1].data = data.avg_dom_last_year.map((v: any) => v.value);
        (optionAvgDom.series[1] as any).itemStyle = barStyle2;
        this.optionAvgDom = optionAvgDom;
    }
    public renderSlrOfYear(rawData: any) {
        const month = rawData.month;
        const this_year = rawData.year;
        const data: any = {
            'avg_slr_this_year': [],
            'avg_slr_last_year': []
        };
        for (let i = 7; i >= 0; i--) {
            let monthNum = (month - i);
            let yearBase = this_year;
            if (monthNum === 0) {
                monthNum = 12;
                yearBase = yearBase - 1;
            } else if ( monthNum < 0) {
                monthNum = (monthNum + 12) % 12;
                yearBase = yearBase - 1;
            }
            data.avg_slr_this_year.push({
                month: monthNum,
                year: yearBase,
                value: rawData.slrAvgThis[rawData.slrAvgThis.length - 1 - i]
            });
            data.avg_slr_last_year.push({
                month: monthNum,
                year: yearBase - 1,
                value: rawData.slrAvgLast[rawData.slrAvgLast.length - 1 - i]
            });
        }
        const periodThisYear =  this.getPeriod(data.avg_slr_this_year);
        const periodLastYear =  this.getPeriod(data.avg_slr_last_year);
        (optionSlr.legend.data as any) = [`${periodThisYear}`, `${periodLastYear}`];
        optionSlr.xAxis[0].data = data.avg_slr_this_year.map((v: any) => `${this.monthTrans(v.month - 1)}`);
        optionSlr.series[0].name = `${periodThisYear}`;
        optionSlr.series[0].data = data.avg_slr_this_year.map((v: any) => (v.value * 1.0).toFixed(2));
        optionSlr.series[1].name = `${periodLastYear}`;
        optionSlr.series[1].data = data.avg_slr_last_year.map((v: any) => (v.value * 1.0).toFixed(2));
        (optionSlr.series[0] as any).itemStyle = barStyle;
        (optionSlr.series[1] as any).itemStyle = barStyle2;
        this.optionSlr = optionSlr;
    }
    public renderSalesOfYear(rawData: any) {
        const month = rawData.month;
        const this_year = rawData.year;
        const data: any = {
            'sales_this_year': [],
            'sales_last_year': []
        };
        for (let i = 7; i >= 0; i--) {
            let monthNum = (month - i);
            let yearBase = this_year;
            if (monthNum === 0) {
                monthNum = 12;
                yearBase = yearBase - 1;
            } else if ( monthNum < 0) {
                monthNum = (monthNum + 12) % 12;
                yearBase = yearBase - 1;
            }
            data.sales_this_year.push({
                month: monthNum,
                year: yearBase,
                value: rawData.salesSumThis[rawData.salesSumThis.length - 1 - i]
            });
            data.sales_last_year.push({
                month: monthNum,
                year: yearBase - 1,
                value: rawData.salesSumLast[rawData.salesSumLast.length - 1 - i]
            });
        }
        const periodThisYear =  this.getPeriod(data.sales_this_year);
        const periodLastYear =  this.getPeriod(data.sales_last_year);

        (optionSales.legend.data as any) = [`${periodThisYear}`, `${periodLastYear}`];
        optionSales.xAxis[0].data = data.sales_this_year.map((v: any) => `${this.monthTrans(v.month - 1)}`);
        optionSales.series[0].name = `${periodThisYear}`;
        optionSales.series[0].data = data.sales_this_year.map((v: any) => v.value);
        optionSales.series[1].name = `${periodLastYear}`;
        optionSales.series[1].data = data.sales_last_year.map((v: any) => v.value);
        (optionSales.series[0] as any).itemStyle = barStyle;
        (optionSales.series[1] as any).itemStyle = barStyle2;
        this.optionSales = optionSales;

    }
    public phaseOneFirstDataMap(data: any) {
        // this.renderPriceDom(data);
        // this.renderAvgPriceOfYear(data);
        // this.renderMedPriceOfYear(data);
    }
    public phaseOneSecondDataMap(data: any) {
        // this.renderDomOfYear(data);
        // this.renderSlrOfYear(data);
        // this.renderSalesOfYear(data);
    }
    public propertyTrans(type: string) {
        const pMap: {[key: string]: string} = {
            'Condo Townhouse': '公寓镇屋',
            'Condo': '公寓',
            'Detached': '独立屋',
            'Land': '土地',
            'Other': '其他',
            'Semi-Detached': '半独立屋',
            'Townhouse': '排屋'
        };
        if (pMap[type]) {
            if (this.renderCN) {
                return pMap[type];
            } else {
                return type;
            }
        } else {
            return '';
        }
    }
    public getPropertyType(ind: number) {
        const propertyTypeMap: any = [
            'Detached',
            'SemiDetached',
            'Townhome',
            'Condo'
        ];
        if (propertyTypeMap[ind]) {
            return propertyTypeMap[ind];
        } else {
            return 'Detached';
        }
    }
    public getPropertyTypeTims(ind: number) {
        const propertyTypeMap: any = [
            'Detached',
            'Semi-Detached',
            'Townhouse',
            'Condo'
        ];
        if (propertyTypeMap[ind]) {
            return propertyTypeMap[ind];
        } else {
            return 'Detached';
        }
    }
    public renderPie(rawData: any) {
        const self = this;
        const data = Object.keys(rawData.propertyTypeDistribution).map(key => {
            return {
                count: rawData.propertyTypeDistribution[key],
                propertyType: key
            };
        });
        const sum = data.reduce(function(acc: any, b: any) { return acc + b.count; }, 0);
        (optionPie.series[0].data as any) = data.map((v: any) => {
            const percent = ((v.count * 1.0 / sum) * 100).toFixed(2);
            return {
                value: v.count,
                name: self.propertyTrans(v.propertyType) + ` (${percent}%) `
            };
        }).sort(function (a: any, b: any) { return a.value - b.value; });
        (optionPie.legend.data as any) = optionPie.series[0].data.map((v: any) => {
            return v.name;
        });
        this.optionPie = optionPie;
    }
    public renderNewSoldNow(rawData: any) {
        if (!rawData.activeNumbers.length) {
            this.optionHistoryData = null;
            return;
        }
        const month = rawData.month;
        const this_year = rawData.year;

        const data: any = {
            'historyCount': []
        };
        for (let i = 20; i >= 0; i--) {
            let monthNum = (month - i);
            let yearBase = this_year;
            const ind = rawData.activeNumbers.length - 1 - i;
            if (monthNum === 0) {
                monthNum = 12;
                yearBase = yearBase - 1;
            } else if ( monthNum < 0 && monthNum > -12) {
                monthNum = (monthNum + 12) % 12;
                yearBase = yearBase - 1;
            } else if (monthNum === -12) {
                monthNum = 12;
                yearBase = yearBase - 2;
            } else if ( monthNum < -12 ) {
                monthNum = (monthNum + 24) % 12;
                yearBase = yearBase - 2;
            }
            data.historyCount.push({
                month: monthNum,
                year: yearBase,
                active_listing: rawData.activeNumbers[ind],
                new_listing: rawData.newListings[ind],
                sales: rawData.soldListings[ind],
            });
        }
        (optionNewSoldActive.legend.data as any) = [
            this.$t('marketingTrend.graph9.label3'),
            this.$t('marketingTrend.graph9.label2'),
            this.$t('marketingTrend.graph9.label1')
        ];
        optionNewSoldActive.xAxis[0].data = data.historyCount.map((v: any) => `${v.year}/${v.month}`);
        (optionNewSoldActive.series[0].name as any) = this.$t('marketingTrend.graph9.label3');
        optionNewSoldActive.series[0].data = data.historyCount.map((v: any) => v.active_listing);
        (optionNewSoldActive.series[0] as any).itemStyle = barStyle3;
        (optionNewSoldActive.series[1].name as any) = this.$t('marketingTrend.graph9.label2');
        optionNewSoldActive.series[1].data = data.historyCount.map((v: any) => v.new_listing);
        (optionNewSoldActive.series[2].name as any) = this.$t('marketingTrend.graph9.label1');
        optionNewSoldActive.series[2].data = data.historyCount.map((v: any) => v.sales);
        this.optionHistoryData = optionNewSoldActive;
    }
    public renderAbortion(rawData: any) {
        if (!rawData.absorptionMonths.length) {
            this.optionAbortion = null;
            return;
        }
        const month = rawData.month;
        const this_year = rawData.year;

        const data: any = {
            'historyCount': []
        };
        for (let i = 20; i >= 0; i--) {
            let monthNum = (month - i);
            let yearBase = this_year;
            const ind = rawData.activeNumbers.length - 1 - i;
            if (monthNum === 0) {
                monthNum = 12;
                yearBase = yearBase - 1;
            } else if ( monthNum < 0 && monthNum > -12) {
                monthNum = (monthNum + 12) % 12;
                yearBase = yearBase - 1;
            } else if (monthNum === -12) {
                monthNum = 12;
                yearBase = yearBase - 2;
            } else if ( monthNum < -12 ) {
                monthNum = (monthNum + 24) % 12;
                yearBase = yearBase - 2;
            }
            data.historyCount.push({
                month: monthNum,
                year: yearBase,
                abortion_rate: rawData.absorptionRates[ind],
                abortion_month: rawData.absorptionMonths[ind],
            });
        }

        optionAbortion.xAxis[0].data = data.historyCount.map((v: any) => `${v.year}/${v.month}`);
        (optionAbortion.series[0].name as any) = this.$t('marketingTrend.graph10.label1');
        optionAbortion.series[0].data = data.historyCount.map((v: any) => v.abortion_rate.toFixed(2));
        (optionAbortion.series[1].name as any) = this.$t('marketingTrend.graph10.label2');
        optionAbortion.series[1].data = data.historyCount.map((v: any) => parseInt(v.abortion_month, 10));
        optionAbortion.series[0].itemStyle = barStyle;
        (optionAbortion.tooltip.formatter as any) = this.$t('marketingTrend.graph10.formatter');
        this.optionAbortion = optionAbortion;
    }

    public renderPriceDistribute(rawData: any) {
        const data = Object.keys(rawData.soldPriceDistribution).map(key => {
            return {
                soldPrice: 200000 * Number(key),
                number: rawData.soldPriceDistribution[key]
            };
        });
        (optionPriceDistribute.yAxis[0].name as any) =  this.$t('marketingTrend.graph8.label1');
        (optionPriceDistribute.xAxis[0].data as any) = data.map((v: any) => `${v.soldPrice / 1000}K`);
        (optionPriceDistribute.series[0].data as any) =  data.map((v: any) => v.number);
        (optionPriceDistribute.series[0] as any).itemStyle = barStyle;
        this.optionPriceDistribute = optionPriceDistribute;
    }

    public mapCurrentData(rawData: any) {
        return [{
            med_price: rawData.medPriceThisMonth * 1000.0
        }, {
            new_listing_number: rawData.newListingSum
        }, {
            med_price_change_month: rawData.monthlyMedPriceGrowth
        }, {
            med_price_change_year: rawData.yearlyMedPriceGrowth
        }, {
            sales: rawData.salesSum
        }, {
            avg_dom: rawData.domAvg
        }, {
            avg_price: rawData.priceAvg * 1000.0
        }, {
            avg_slr: rawData.slrAvg / 100.0
        }];
    }
    public clearOptions() {
        this.optionPriceDom =  null;
        this.optionAvgPrice =  null;
        this.optionMedPrice =  null;
        this.optionAvgDom =  null;
        this.optionSlr =  null;
        this.optionSales =  null;
        this.optionAvgSaleDay =  null;
        this.optionPie =  null;
        this.optionHistoryData =  null;
        this.optionCurrentData =  null;
        this.optionAbortion =  null;
        this.optionPriceDistribute =  null;
        this.currentData = null;
    }
    public async renderStatistics() {
        this.clearOptions();
        const self = this;
        setTimeout(async function() {
            try {
                self.loading1 = true;
                const fetchedAll  = await AxiosPromise.postUrlEncode(`http://tims.realjaja.com/api/quotations/findQuotations.json`, {
                    city: self.city === 'all' ? null : self.city ,
                    community: self.community === 'all' ? null : self.community ,
                    propertyNew: self.getPropertyTypeTims(self.propertyTypeInd)
                });
                self.loading1 = false;
                self.currentData = self.mapCurrentData(fetchedAll.data.data);
                self.periodSel = {
                    year: moment().year(),
                    month: moment().month() + 1,
                    month_last: moment().subtract(1, 'months').month() + 1,
                    year_last: moment().subtract(1, 'months').year(),
                };
                self.renderPriceDom(fetchedAll.data.data);
                self.renderAvgPriceOfYear(fetchedAll.data.data);
                self.renderMedPriceOfYear(fetchedAll.data.data);
                self.renderDomOfYear(fetchedAll.data.data);
                self.renderSlrOfYear(fetchedAll.data.data);
                self.renderSalesOfYear(fetchedAll.data.data);
                self.renderNewSoldNow(fetchedAll.data.data);
                self.renderAbortion(fetchedAll.data.data);
                self.renderPie(fetchedAll.data.data);
                self.renderPriceDistribute(fetchedAll.data.data);
            } catch (e) {

            }
        });
    }
    @Watch('globalPudge', { immediate: true, deep: true })
    public async onEpicContext(globalPudge: any, globalPudgeOld: any) {
        const language = globalPudge.getParam('language')
            ? parseInt(globalPudge.getParam('language') , 10)
            : 0;
        if (language === 1) {
            this.propertyTypes = [
                'Detached',
                'SemiDetached',
                'Townhome',
                'Condo'
            ];
            this.renderCN = false;
        }
        if (language === 0) {
            this.propertyTypes = ['独立屋', '半独立屋', '联排', '公寓'];

            this.renderCN = true;
        }
    }
    public async created() {
        // (window as any).epicFunctions.setParam('language', this.$route.query.ltype);
        await this.fetchAllCitys();
        await this.renderStatistics();
    }

    public async fetchAllCitys() {
        const fetchedCitys  = await AxiosPromise.postUrlEncode(`${this.configs.smartSelectionService}/findCityByProvince.json`, {
            province: 'Ontario'
        });
        if (fetchedCitys && fetchedCitys.data && fetchedCitys.data.data) {
            this.allCities = fetchedCitys.data.data;
            this.allCities.unshift('all');
        }
    }
    public async getAllCommunities(city: string) {
        const fetchedCommus  = await AxiosPromise.postUrlEncode(`${this.configs.smartSelectionService}/findCommunityByCity.json`, {
            city: city
        });
        if (fetchedCommus && fetchedCommus.data && fetchedCommus.data.data) {
            this.allCommunities = fetchedCommus.data.data;
            this.allCommunities.unshift('all');
        }
    }

    public async mounted() {
        // (window as any).epicFunctions.setParam('language', 1);
    }
}
